var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .75C0 .335786.335786 0 .75 0h11.5c.4142 0 .75.335786.75.75v9.22727c0 .41423-.3358.75003-.75.75003H5.64381l-1.2925 1.9387c-.1391.2087-.37327.334-.62404.334-.25076 0-.48494-.1253-.62403-.334l-1.29251-1.9387H.75c-.414214 0-.75-.3358-.75-.75003V.75Zm1.5.75v7.72727h.71212c.25077 0 .48494.12533.62404.33398l.89111 1.33665.89112-1.33665c.1391-.20865.37327-.33398.62403-.33398H11.5V1.5h-10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 5.75c0-.41421.3358-.75.75-.75h2.75c.4142 0 .75.33579.75.75v9.2273c0 .4142-.3358.75-.75.75h-1.0986l-1.2925 1.9387c-.1391.2087-.3733.334-.6241.334-.2507 0-.4849-.1253-.624-.334l-1.2925-1.9387H6c-.41421 0-.75-.3358-.75-.75V12.5c0-.4142.33579-.75.75-.75s.75.3358.75.75v1.7273h5.9697c.2508 0 .4849.1253.624.3339l.8911 1.3367.8912-1.3367c.1391-.2086.3732-.3339.624-.3339h.75V6.5h-2c-.4142 0-.75-.33579-.75-.75Z",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.448945ce5d7860598fd5a0e826429173.svg";
export { ForwardRef as ReactComponent };